var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.8,
    height: 22.8,
    viewBox: "0 0 22.8 22.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-315.879 -288.426)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8,
    height: 22.8,
    fill: "#1291d9",
    rx: 11.4,
    transform: "translate(315.879 288.426)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M330.314 299.538l-1.4 1.969a1.862 1.862 0 0 0-.329.984v.548h-1.86v-.639a2.688 2.688 0 0 1 .62-1.8l1.423-1.915a2.312 2.312 0 0 0 .565-1.385 1.753 1.753 0 0 0-1.787-1.824 1.676 1.676 0 0 0-1.676 1.212.842.842 0 0 1-.788.63h-.143a.887.887 0 0 1-.838-1.168 3.493 3.493 0 0 1 3.445-2.333 3.444 3.444 0 0 1 3.647 3.483 3.733 3.733 0 0 1-.879 2.238zm-3.7 6.487v-.225a.878.878 0 0 1 .879-.879h.3a.878.878 0 0 1 .879.879v.229a.878.878 0 0 1-.879.879h-.3a.878.878 0 0 1-.88-.883z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.beb2de86.svg";
export { ForwardRef as ReactComponent };